import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-stripe',
  templateUrl: './payment-panel-stripe.component.html',
})
export class PaymentPanelStripeComponent {}
